import React from 'react'

export function DropdownArrowIcon(props: { expanded: boolean }) {
    return (
        <zaptic-rotating-chevron data-testid="tree-select-expand-toggle" direction={props.expanded ? 'up' : 'down'} />
    )
}
